var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { createThunk } from '../../../common';
import { getAssemblyInferredLayers, getAssemblyPropertyAvailability, getAssemblyPropertyBaseline, getAssemblySearchResults } from '../../../services/TempAssemblySearchApiService';
import { formatRangeLabel, idFacetColumnNames, rangeColumnNames } from '../states';
import { AssemblySearchActionType } from './AssemblySearchActions'; // pins S/A to this feature's state/action types so individual thunks below don't repeat them
var createAssemblySearchThunk = function (f) { return createThunk(f); }; // fetches the constant/baseline set of assembly property values (id + range columns) with no
// filters applied and replaces the mock data currently in state; called once on mount so the
// button groups/dropdowns never reshuffle afterwards. includesPv and the roof layer cake are not
// requested yet since that work is handled later
var loadAssemblyPropertyBaseline = createAssemblySearchThunk(function () { return function (_a) { return __awaiter(void 0, [_a], void 0, function (_b) {
    var facetMap;
    var dispatch = _b.dispatch, getState = _b.getState;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0: return [4 /*yield*/, getAssemblyPropertyBaseline(getState())];
            case 1:
                facetMap = _c.sent();
                Object.keys(idFacetColumnNames).forEach(function (facetId) {
                    var _facetMap$idFacetColu;
                    var facetValues = (_facetMap$idFacetColu = facetMap[idFacetColumnNames[facetId]]) !== null && _facetMap$idFacetColu !== void 0 ? _facetMap$idFacetColu : {};
                    dispatch({ type: AssemblySearchActionType.idFacetsLoaded, facetId: facetId, // no client-side sort: preserves whatever domain-specific order the backend returns
                        // (e.g. NC before 1 for fire ratings), which alphabetical/numeric sorting can't reproduce
                        values: Object.entries(facetValues).map(function (_a) {
                            var value = _a[0], facet = _a[1];
                            return ({ value: value, label: facet.name, count: facet.count });
                        }) });
                });
                Object.keys(rangeColumnNames).forEach(function (facetId) {
                    var _facetMap$rangeColumn;
                    var facetValues = (_facetMap$rangeColumn = facetMap[rangeColumnNames[facetId]]) !== null && _facetMap$rangeColumn !== void 0 ? _facetMap$rangeColumn : {};
                    dispatch({ type: AssemblySearchActionType.rangeFacetsLoaded, facetId: facetId, values: Object.entries(facetValues).map(function (_a) {
                            var value = _a[0], facet = _a[1];
                            return ({ value: value, label: formatRangeLabel(facet.name), count: facet.count });
                        }) // numeric ascending so the dropdown reads like the RoofNav web UI (60, 75, 90, ...)
                            .sort(function (a, b) { return Number(a.value) - Number(b.value); }) });
                });
                dispatch({ type: AssemblySearchActionType.baselineLoaded });
                return [2 /*return*/];
        }
    });
}); }; }); // fetches which baseline assembly property values are still obtainable given the currently
// selected filters, so unavailable options can be disabled without changing the button group's
// constant option list
var loadAssemblyPropertyAvailability = createAssemblySearchThunk(function () { return function (_a) { return __awaiter(void 0, [_a], void 0, function (_b) {
    var state, facetMap, rangeFacetIds;
    var dispatch = _b.dispatch, getState = _b.getState;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                state = getState();
                return [4 /*yield*/, getAssemblyPropertyAvailability(state)];
            case 1:
                facetMap = _c.sent();
                Object.keys(idFacetColumnNames).forEach(function (facetId) { var _facetMap$idFacetColu2; dispatch({ type: AssemblySearchActionType.idFacetAvailabilityLoaded, facetId: facetId, availableValues: Object.keys((_facetMap$idFacetColu2 = facetMap[idFacetColumnNames[facetId]]) !== null && _facetMap$idFacetColu2 !== void 0 ? _facetMap$idFacetColu2 : {}) }); }); // computed per range facet, excluding that facet's own operator/value filter - otherwise an
                rangeFacetIds = Object.keys(rangeColumnNames);
                return [4 /*yield*/, Promise.all(rangeFacetIds.map(function (facetId) { return __awaiter(void 0, void 0, void 0, function () { var _rangeFacetMap$rangeC, rangeFacetMap; return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0: return [4 /*yield*/, getAssemblyPropertyAvailability(state, facetId)];
                            case 1:
                                rangeFacetMap = _a.sent();
                                dispatch({ type: AssemblySearchActionType.rangeFacetAvailabilityLoaded, facetId: facetId, availableValues: Object.keys((_rangeFacetMap$rangeC = rangeFacetMap[rangeColumnNames[facetId]]) !== null && _rangeFacetMap$rangeC !== void 0 ? _rangeFacetMap$rangeC : {}) });
                                return [2 /*return*/];
                        }
                    }); }); }))];
            case 2:
                _c.sent();
                return [2 /*return*/];
        }
    });
}); }; }); // fetches real assembly results matching the currently selected assembly-property filters
var loadAssemblySearchResults = createAssemblySearchThunk(function () { return function (_a) { return __awaiter(void 0, [_a], void 0, function (_b) {
    var _c, results, totalCount, inferredLayers;
    var dispatch = _b.dispatch, getState = _b.getState;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                dispatch({ type: AssemblySearchActionType.searchResultsRequested });
                return [4 /*yield*/, getAssemblySearchResults(getState())];
            case 1:
                _c = _d.sent(), results = _c.results, totalCount = _c.totalCount, inferredLayers = _c.inferredLayers;
                dispatch({ type: AssemblySearchActionType.searchResultsLoaded, results: results, resultCount: totalCount });
                dispatch({ type: AssemblySearchActionType.inferredLayersLoaded, layers: inferredLayers });
                return [2 /*return*/];
        }
    });
}); }; }); // refreshes the inferred layers (and so the layers offered by the picker) for the current selection
var loadAssemblyInferredLayers = createAssemblySearchThunk(function () { return function (_a) { return __awaiter(void 0, [_a], void 0, function (_b) {
    var layers;
    var dispatch = _b.dispatch, getState = _b.getState;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0: return [4 /*yield*/, getAssemblyInferredLayers(getState())];
            case 1:
                layers = _c.sent();
                dispatch({ type: AssemblySearchActionType.inferredLayersLoaded, layers: layers });
                return [2 /*return*/];
        }
    });
}); }; });
var addAssemblyLayer = createAssemblySearchThunk(function (layerTypeId, index) { return function (_a) {
    var dispatch = _a.dispatch;
    dispatch({ type: AssemblySearchActionType.addLayer, layerTypeId: layerTypeId, index: index });
}; });
var removeAssemblyLayer = createAssemblySearchThunk(function (index) { return function (_a) {
    var dispatch = _a.dispatch;
    dispatch({ type: AssemblySearchActionType.removeLayer, index: index });
}; });
var saveAssemblyLayerDetails = createAssemblySearchThunk(function (index, details) { return function (_a) {
    var dispatch = _a.dispatch;
    dispatch({ type: AssemblySearchActionType.saveLayerDetails, index: index, details: details });
}; }); // clears every assembly-property filter
var clearAllAssemblySearchFilters = createAssemblySearchThunk(function () { return function (_a) {
    var dispatch = _a.dispatch;
    dispatch({ type: AssemblySearchActionType.clearAllAssemblyFilters });
}; });
export { addAssemblyLayer, clearAllAssemblySearchFilters, loadAssemblyInferredLayers, loadAssemblyPropertyAvailability, loadAssemblyPropertyBaseline, loadAssemblySearchResults, removeAssemblyLayer, saveAssemblyLayerDetails };
